/**
 * @description helper function that capitalizes the string
 * @example 'something' -> 'Something'
 * @param {string} value
 * @returns {string}
 */
export const capitalize = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1);
